import React, { useEffect, useState } from "react";
import AlertField from "../Components/AlertField";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import { useLocation } from "react-router-dom";
import useAuth from "../Hooks/useAuth";
import Paginate from "../Components/Paginate";
import Records from "../Components/Records";
import ConfirmationModal from "../Components/ConfirmationModal";

const ReviewTable = () => {
  const { auth } = useAuth();
  const { state } = useLocation();
  const [alert, setAlert] = useState(state ? state : null);
  const axiosPrivate = useAxiosPrivate();
  const [list, setList] = useState({});
  const [pageCount, setpageCount] = useState(0);
  const [count, setCount] = useState(0);
  const [endValue, setEndValue] = useState(0);
  const [startValue, setStartValue] = useState(1);
  const [limit, setLimit] = useState("10");

  useEffect(() => {
    let timeoutId = setTimeout(() => {
      setAlert(null);
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  useEffect(() => {
    //gets list with limit 10 at first load
    getInitialList(limit);
  }, []);

  const getInitialList = async (limit) => {
    try {
      const response = await axiosPrivate.get(`review/list?limit=${limit}`, {});
      //sets the list of data got from api
      setList(response?.data.results);
      //gets the total record and divides by 10 to set pagination number
      setpageCount(Math.ceil(response.data.count / 10));
      //sets the total number of record to display in bottom message
      setCount(response?.data.count);
      //sets the start and end value as length of records got
      setStartValue(1);
      setEndValue(response?.data.results.length);
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else {
        showAlert("Load Failed", "warning");
      }
    }
  };

  const getList = async (limit, offset) => {
    //it gets the value of limit to get number of records
    const res = await axiosPrivate.get(
      `review/list?limit=${limit}&offset=${offset}`,
      {}
    );
    return res;
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected * limit;
    //calls the api with limit and currentpage as offset and get response data
    const response = await getList(limit, currentPage);

    //sets response into list
    setList(response?.data.results);
    //sets start and end value
    setStartValue(data.selected * limit + 1);
    setEndValue(data.selected * limit + response?.data.results.length);
    //sets 0 to start and end value if records on response is 0
    if (response?.data.results.length === 0) {
      setStartValue(0);
      setEndValue(0);
    }
  };

  const handleRecordClick = async (data) => {
    //make sure api does not hit when record value is same
    if (data.target.value !== limit) {
      //calls the api with new limit chosen
      getInitialList(data.target.value);
      setLimit(data.target.value);
    }
  };

  const onDelete = async (id) => {
    try {
      await axiosPrivate.delete(`review/${id}`);
      showAlert("Review Deleted.", "success");

      //reloads the data in table
      getInitialList(limit);
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else {
        showAlert("Deletion Failed", "warning");
      }
    }

    //closes the modal form
    document.getElementById(`confirmationModal${id}-close`).click();
  };

  return (
    <div>
      <AlertField alert={alert} />

      <h2 className="text-center py-2">Reviews</h2>
      <div className="mx-5 px-5">
        <div className="d-flex justify-content-between">
          <Records handleRecordClick={handleRecordClick} />
        </div>
        <div className="table-responsive">
          <table
            data-toggle="table"
            className="table table-light table-hover"
            data-pagination="true"
            data-search="true"
          >
            <thead>
              <tr>
                <th scope="col">Review ID</th>
                {auth?.user.roles === 0 && <th scope="col">Reviewer's Name</th>}
                <th scope="col">Description</th>
                <th scope="col">To</th>
                <th scope="col">Reviewed Date</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {list?.length ? (
                list.map((list, i) => (
                  <tr key={i}>
                    <td>{list?.id}</td>
                    {auth?.user.roles === 0 && (
                      <td>{list?.review_by.user_detail.name}</td>
                    )}
                    <td>{list?.description}</td>
                    <td>
                      {list?.to === "System"
                        ? list?.to
                        : `Dr. ${list?.doctor_review[0].doctor_id.user_detail.name}`}
                    </td>
                    <td>{list?.review_date}</td>
                    <td>
                      {auth?.user.roles !== 1 && (
                        <ConfirmationModal
                          button="Delete"
                          target={`confirmationModal${list?.id}`}
                          btnClass="btn py-0 btn-danger"
                          title="Delete Confirmation"
                          body={`Are you sure you want to delete review ${
                            auth?.user?.roles === 0
                              ? `by ${list?.review_by.user_detail.name}`
                              : `to ${
                                  list?.to === "System"
                                    ? list?.to
                                    : `Dr. ${list?.doctor_review[0].doctor_id.user_detail.name}`
                                }`
                          }?`}
                          close="No"
                          save="Yes"
                          onClick={() => onDelete(list?.id)}
                        />
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    No Reviews
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Paginate
          startValue={startValue}
          endValue={endValue}
          count={count}
          pageCount={pageCount}
          handlePageClick={handlePageClick}
        />
      </div>
    </div>
  );
};

export default ReviewTable;
